export type PublicPhotoRepresentation = { assetId?: string; url?: string };

function isUnavailableHistoricalAsset(error: unknown): boolean {
  return Boolean(
    error &&
    typeof error === 'object' &&
    'code' in error &&
    ((error as { code?: unknown }).code === 'RESOURCE_NOT_FOUND' ||
      (error as { code?: unknown }).code === 'ACCESS_DENIED'),
  );
}

/**
 * A stale private-media row must not make an otherwise valid social page unusable.
 * Transport and server failures still reject so the normal bounded query retry/error state remains.
 */
export async function hydratePublicProfilePhotos<
  T extends { photos?: PublicPhotoRepresentation[] },
>(card: T, access: (assetId: string) => Promise<{ url: string }>): Promise<T> {
  const photos = await Promise.all(
    (card.photos ?? []).map(async (photo) => {
      if (!photo.assetId) return photo;
      try {
        return { ...photo, ...(await access(photo.assetId)) };
      } catch (error) {
        if (isUnavailableHistoricalAsset(error)) return null;
        throw error;
      }
    }),
  );
  return {
    ...card,
    photos: photos.filter((photo): photo is PublicPhotoRepresentation => photo !== null),
  };
}
